import { Component, OnInit, ViewChild } from '@angular/core';
import { BackEndService } from 'src/app/backend-service';
import { Router } from '@angular/router';
import { PaginationPage, NextcloudAuthorizationLog, PaginationResponse } from 'src/app/classes';
import * as moment from 'moment';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SessionService } from 'src/app/lib/shared/services/session.service';

@Component({
  selector: 'app-nextcloud-diagnose',
  templateUrl: './nextcloud-diagnose.component.html',
  styleUrls: ['./nextcloud-diagnose.component.css']
})
export class NextcloudDiagnoseComponent implements OnInit {

  requirements: string[] = [""];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  displayedColumns: string[] = ['options', 'auditid', 'auditdate', 'diffdate', 'audituser', 'auditcomponent', 'auditerror'];
  pageSize: number = 30;
  pageNumber = 1;
  dataSource = new MatTableDataSource<NextcloudAuthorizationLog>();

  length: number = 0;

  guidFilter: string = "";

  rightsMap = {
    "use_nextcloud_provider": null
  };

  constructor(
    private backEndService: BackEndService,
    private _sessionService: SessionService
  ) { }

  accessGranted(){
    return this.backEndService.isAllowedAND(this.requirements);
  }

  applyFilter(value: string){
    this.dataSource.filter = value.toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  diffdate(entry: NextcloudAuthorizationLog){
    let entries = this.dataSource.data.filter(x => x.audituser == entry.audituser).sort((a, b) => {
      if(moment(a.auditdate).unix() > moment(b.auditdate).unix()){
        return 1;
      } else if(moment(a.auditdate).unix() < moment(b.auditdate).unix()){
        return -1;
      } else {
        return 0;
      }
    });
    let i = entries.indexOf(entry);
    if(i > 0){
      var unit = "s";
      var diff = moment(entry.auditdate).unix() - moment(entries[i-1].auditdate).unix();
      if(diff > 300){
        diff = (diff/60);
        unit = "min";
      }
      return diff.toFixed(0) + " " + unit;
    }
    return null;
  }

  initRights = (soft: boolean = true) => {
    for (let index in this.rightsMap){
      this._sessionService.hasRight(index, soft).subscribe(result => this.rightsMap[index] = result);
    }
  }

  updatePageIndex(event){
    if(this.dataSource.data.length < (this.pageSize * event.pageIndex+1)){
      let pPage = new PaginationPage();
      pPage.pageSize = this.pageSize;
      pPage.pageNumber = event.pageIndex+1;
      this.backEndService.post("api/nextcloud/log/pagination", pPage).subscribe((result: PaginationResponse<NextcloudAuthorizationLog[]>) => {
        this.dataSource.data = result.content;
        this.pageNumber = result.page.pageNumber;
      });
    }
  }

  ngOnInit() {
    let pPage = new PaginationPage();
    pPage.pageSize = this.pageSize;
    pPage.pageNumber = this.pageNumber;
    this.backEndService.post("api/nextcloud/log/pagination", pPage).subscribe((result: PaginationResponse<NextcloudAuthorizationLog[]>) => {
      this.length = result.totalItems;
      this.dataSource.data = result.content;
    });
  }

  ngAfterViewInit(){
    
  }

  refresh(){
    let pPage = new PaginationPage();
    pPage.pageSize = this.pageSize;
    pPage.pageNumber = this.pageNumber;
    this.backEndService.post("api/nextcloud/log/pagination", pPage).subscribe((result: PaginationResponse<NextcloudAuthorizationLog[]>) => {
      this.length = result.totalItems;
      this.dataSource.data = result.content;
    });
  }

  splitByComma(rules: string){
    if(rules) return rules.split(",");
    return "";
  }


}
